import { app } from '@df/core/app';
import { ICMS_CLIENT_CONFIG, NICmsClientConfig } from '@icms/client/config/icms-client.config';
import { NICmsContentField } from '@icms/core/content';
import { validateRatio } from './df-ratio-validation';

export const ratioField = (fieldParams: Partial<NICmsContentField.IField> = {}) =>
    <NICmsContentField.ITextSelectField>{
        key: fieldParams.key || 'ratio',
        type: NICmsContentField.EFieldType.textSelect,
        title: fieldParams.title || 'Ratio',
        options: () => app.injector.get<NICmsClientConfig.IConfig>(ICMS_CLIENT_CONFIG).ratios || [],
        validateFn: value => !value || validateRatio(value),
        description: 'Format: width/height (3/2), width-height (3-2), numeric (0.75)',
        ...fieldParams
    };
